import { FC, ReactNode } from 'react';

import { Text, TextTypography } from '@hh.ru/magritte-ui';

import styles from './styles.less';

interface Props {
    strings: string[];
    typography: TextTypography | null;
}

interface WrapperProps {
    typography: Props['typography'];
    children: ReactNode;
}

const Wrapper: FC<WrapperProps> = ({ typography, children }) => {
    return typography ? (
        <Text typography={typography} Element="div">
            {children}
        </Text>
    ) : (
        <>{children}</>
    );
};

const DottedList: FC<Props> = ({ strings = [], typography }) => (
    <Wrapper typography={typography}>
        <ul className={styles.list}>
            {strings.map((s, i) => (
                <li key={i}>{s}</li>
            ))}
        </ul>
    </Wrapper>
);

export default DottedList;
